module.exports = __webpack_public_path__ + "static/media/sleep-basics@3x.ab2555a0.png";